import { Component, AfterViewInit, OnChanges, EventEmitter, Input, Output, ElementRef, Renderer } from '@angular/core';

@Component({
    selector: 'cui-dialog',
    templateUrl: './cui-dialog.component.html'
})
export class CUIDialogComponent {
    @Input() show: boolean;
    @Input() width: number = 300;
    @Input() id: string;
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Output() onShow: EventEmitter<any> = new EventEmitter();

    listener: Function;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer
    ) { }

    ngAfterViewInit(): void {
        let closeButton = this.elementRef.nativeElement.querySelector('.ui-dialog-titlebar-close');
        this.listener = this.renderer.listen(closeButton, 'click', (event) => {
            this.emitClose();
        });
    }

    ngOnChanges(changes: any): void {
        if (changes.show !== undefined && changes.show.currentValue == false) {
            this.emitClose();
        }
    }

    ngOnDestroy() {
        this.listener();
    }

    /**
     * @function emits a onClose event to the implementing feature component when the close (x) button is clicked
     * @returns void
     */
    emitClose(): void {
        this.onClose.emit();
    }

    emitAfterShow(): void {
        this.onShow.emit();
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-dialog/cui-dialog.component.ts